import React from 'react';
import { GraduationCapIcon, MessageCircleIcon } from 'lucide-react';
export function QualificationSection() {
  return <section className="bg-gray-light py-20 px-4" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        {/* Authority Section */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-md mb-16 text-center border-t-4 border-navy" data-id="element-177">
          <div className="flex justify-center mb-6" data-id="element-178">
            <GraduationCapIcon className="w-16 h-16 text-navy" data-id="element-179" />
          </div>
          <h2 className="text-3xl font-heading font-bold text-navy mb-4" data-id="element-180">
            Información Diseñada Para Principiantes
          </h2>
          <p className="text-xl text-text-muted max-w-2xl mx-auto" data-id="element-181">
            Creado específicamente para personas que desean construir crédito
            correctamente desde el inicio{' '}
            <strong data-id="element-182">sin experiencia financiera previa</strong>. Todo está
            explicado con un lenguaje simple, directo y sumamente práctico.
          </p>
        </div>

        {/* Objections Section */}
        <h2 className="text-3xl font-heading font-bold text-navy mb-10 text-center" data-id="element-183">
          "¿Funcionará para mí si...?"
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
          <div className="bg-white p-6 rounded-xl shadow-sm flex items-start" data-id="element-185">
            <MessageCircleIcon className="w-8 h-8 text-green mr-4 flex-shrink-0 mt-1" data-id="element-186" />
            <div data-id="element-187">
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-188">
                "No tengo nada de crédito"
              </h3>
              <p className="text-text-muted" data-id="element-189">
                Perfecto. El ebook te enseña exactamente cómo abrir tu primer
                producto financiero sin ser rechazado.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm flex items-start" data-id="element-190">
            <MessageCircleIcon className="w-8 h-8 text-green mr-4 flex-shrink-0 mt-1" data-id="element-191" />
            <div data-id="element-192">
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-193">
                "No entiendo de finanzas"
              </h3>
              <p className="text-text-muted" data-id="element-194">
                No necesitas ser un experto. El lenguaje es 100% amigable, sin
                términos técnicos confusos.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm flex items-start" data-id="element-195">
            <MessageCircleIcon className="w-8 h-8 text-green mr-4 flex-shrink-0 mt-1" data-id="element-196" />
            <div data-id="element-197">
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-198">
                "Ya me rechazaron antes"
              </h3>
              <p className="text-text-muted" data-id="element-199">
                Aprenderás por qué te rechazaron y cómo reestructurar tu perfil
                para que te aprueben la próxima vez.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm flex items-start" data-id="element-200">
            <MessageCircleIcon className="w-8 h-8 text-green mr-4 flex-shrink-0 mt-1" data-id="element-201" />
            <div data-id="element-202">
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-203">
                "Creo que es muy complicado"
              </h3>
              <p className="text-text-muted" data-id="element-204">
                El método se resume en pasos claros y accionables. Solo tienes
                que seguir el plan de 90 días incluido.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}